(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs-template"] && !window.DesignMode) return;
  try {
    
    $(".contact-us").click(function() {
      $('html, body').animate({
          scrollTop: $("#customform_data").offset().top
      }, 2000);
  });

  } catch(e) { console.error(e); }
})();
})();
